// export const API = "https://doscouting.com/server";
export const API = process.env.REACT_APP_API || "https://doscouting-backend-2ri1.onrender.com";
